
import { notification } from 'antd'
const isIE = () => { // 判断IE11以下的浏览器（不包括IE11）
  if (window.navigator.userAgent.indexOf("MSIE") >= 1) return true;
  else return false;
}

const HorizontalExport = (params) => {
  if(isIE()){
    notification.info({
      message: '提示',
      description:'该功能不支持IE低版本浏览器'
    })
    return
  }
  import ('./Excel').then((mod)=>{
    mod.default(params)
  })
}

export { HorizontalExport };

export default HorizontalExport;
